import { vars } from '@repo/config';
import { createGetFetchOptions } from './helper';

interface ISessionResponse {
  session?: { user?: unknown } | null;
  user?: unknown;
}

async function fetchAndValidate(url: string, options: RequestInit): Promise<boolean> {
  const response = await fetch(url, options);
  if (!response.ok) {
    return false;
  }
  const data = (await response.json()) as ISessionResponse;
  return data.session != null && data.user != null;
}

export async function checkSession(cookieHeader: string): Promise<boolean> {
  if (!cookieHeader) {
    return false;
  }

  const sessionUrl = new URL('/api/auth/get-session', vars.url.identityUrl).toString();
  const options = createGetFetchOptions({ cookieHeader });

  try {
    return await fetchAndValidate(sessionUrl, options);
  } catch {
    try {
      return await fetchAndValidate(sessionUrl, options);
    } catch {
      return false;
    }
  }
}
